import PDFLoading from '../pdfLoading/pdfLoading';
import NoDataComponent from '../noDataComponent/noDataComponent';
import type { PDFViewerProps } from './types';
import './pdfViewer.scss';

const MESSAGE_ARTIFACT_REPORT =
  'This report could not be generated due to all data being artifact. Please ensure you are checking ECG connection when starting a study';

/**
 * Panel embedding a generated report PDF. Shows PDFLoading while loading, an iframe pointing at the URI-encoded url when one exists and the report is not an artifact report, and otherwise NoDataComponent carrying the artifact-report message.
 *
 * @param isLoading - Whether the report is still being prepared.
 * @param url - Source URL of the PDF to embed.
 * @param isArtifactReport - Whether the report is an artifact report, which is never embedded.
 * @returns The rendered PDF viewer element.
 */
const PDFViewer = ({ isLoading = false, url = '', isArtifactReport = false }: PDFViewerProps) => (
  <div className="pdf-viewer pa3">
    {isLoading ? (
      <PDFLoading />
    ) : url && !isArtifactReport ? (
      <iframe
        id="pdf-viewer"
        title="PDF file"
        src={encodeURI(url)}
        {...({ type: 'application/pdf' } as any)}
        width="100%"
        height="100%"
      />
    ) : (
      <NoDataComponent message={isArtifactReport ? MESSAGE_ARTIFACT_REPORT : undefined} />
    )}
  </div>
);

export default PDFViewer;
